import { useQuery } from "@tanstack/react-query";
import { useDependencies } from "./useDependencies";
import { useAuth } from "./useAuth";
import { useDocumentationAreaIdAndActorId } from "./useDocumentationAreaIdAndActorId";

export const useHasSignedAcceptance = () => {
  const { documentationAreaController } = useDependencies();
  const { token } = useAuth();
  const { documentationAreaId, actorId } = useDocumentationAreaIdAndActorId();

  const queryFn = async () => {
    if (!actorId || !documentationAreaId) {
      throw new Error("ActorId or DocumentationAreaId is missing");
    }
    return await documentationAreaController.getHasSignedAcceptance(
      token,
      documentationAreaId,
      actorId,
    );
  };

  const query = useQuery({
    queryKey: ["getSignedAcceptance", documentationAreaId, actorId],
    queryFn: queryFn,
    enabled: !!documentationAreaId && !!actorId,
  });

  return {
    hasSignedAcceptance: query.data,
    isSignedAcceptanceLoading: query.isPending,
    isSignedAcceptanceSuccess: query.isSuccess,
    isSignedAcceptanceError: query.isError,
    error: query.error,
  };
};
